import type { ViewColumnSpec, ViewEntityType } from "@colab/shared";
import { useUpdateView } from "@/features/admin/views/use-update-view";
import type { SavedView } from "@/features/admin/views/types";
import { ConfigureColumns } from "./configure-columns";

// Phase 7 sub-bucket 19 — small wrapper that ties <ConfigureColumns> to the
// currently-active SavedView. When no view is active, the button is
// disabled (column visibility has no view to persist into — a future "save
// as new view" flow could lift this restriction). When a view is active,
// the wrapper threads the view's columns in and dispatches `useUpdateView`
// on Apply.
//
// Used by submissions / mdf-requests / admin/deals — the three Saved Views
// consumers in Phase 7. The Kanban-style consumers (admin/deals) wire it
// even though the cards are fixed-shape: it persists the user's preference
// into the view for later use on a table-style consumer of the same
// entity_type.
export function ActiveViewColumnsButton({
  entityType,
  activeView,
}: {
  entityType: ViewEntityType;
  activeView: SavedView | null;
}) {
  const updateView = useUpdateView();
  const disabled = !activeView || updateView.isPending;
  const value: ViewColumnSpec[] = activeView?.columns ?? [];

  return (
    <ConfigureColumns
      entityType={entityType}
      value={value}
      disabled={disabled}
      onSave={(next) => {
        if (!activeView) return;
        updateView.mutate({
          id: activeView.id,
          entityType,
          patch: { columns: next },
        });
      }}
    />
  );
}
